import { query, set } from "vue-gtag";

export function gtagQuery(eventName, data) {
  query("event", eventName, data);
}

export function gtagSet(property, data) {
  set(property, data);
}
